import { ComponentTypes } from '../Data/Components';
import { isConditionallyActive } from './conditionality';

export const BLOCK_DISPLAY = {
  DISABLED: 'disabled',
  HIDDEN: 'hidden',
};

export const NAVIGATION_DIRECTION = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
};

// Hidden wins over disabled, so the display does not depend on component order
const getBlockDisplay = (blockingControlSettings, displayKey) =>
  blockingControlSettings.some(
    (settings) => settings[displayKey] === BLOCK_DISPLAY.HIDDEN
  )
    ? BLOCK_DISPLAY.HIDDEN
    : BLOCK_DISPLAY.DISABLED;

const isActiveNavigationControl = ({ components, component }) =>
  component?.component?.type === ComponentTypes.NAVIGATION_CONTROL &&
  isConditionallyActive(components, component);

/**
 * Resolves the navigation restrictions in force on a page. A navigation-control
 * component applies only while its conditional logic is met; a direction is
 * blocked when any active control blocks it, and its button is hidden when any
 * of those blocking controls hides it, otherwise disabled.
 * @param {Object} components - all components in the store, keyed by `component_{id}`
 * @param {Array} pageComponentIds - the ids of the components on the page
 * @returns {{ isForwardBlocked: boolean, isBackwardBlocked: boolean, forwardBlockDisplay: string, backwardBlockDisplay: string }}
 */
export const getNavigationControlState = ({ components, pageComponentIds }) => {
  const activeControlSettings = (pageComponentIds || [])
    .map((componentId) => components[`component_${componentId}`])
    .filter((component) => isActiveNavigationControl({ components, component }))
    .map((component) => component.component.additionalSettings || {});

  const forwardBlockingControls = activeControlSettings.filter(
    (settings) => settings.block_forward
  );
  const backwardBlockingControls = activeControlSettings.filter(
    (settings) => settings.block_backward
  );

  return {
    isForwardBlocked: forwardBlockingControls.length > 0,
    isBackwardBlocked: backwardBlockingControls.length > 0,
    forwardBlockDisplay: getBlockDisplay(
      forwardBlockingControls,
      'forward_block_display'
    ),
    backwardBlockDisplay: getBlockDisplay(
      backwardBlockingControls,
      'backward_block_display'
    ),
  };
};
